import { DetailsSectionFlowContent } from 'app/main/components/page-layouts';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import ChronologyEvents from './ChronologyEvents';

import ChronologyDetailsSectionInfo from './details/sections/ChronologyDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<ChronologyDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="chro_descriptionhtml"
				value={props.model.chro_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_FLOW_SECTION" />
			<DetailsSectionFlowContent module="chronology" {...props} />
		</>
	),
	events: ChronologyEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
